import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

const PromptWrapper = styled.div`
  display: flex;
  flex: 0 1 auto;
  flex-direction: column;
  margin: 2em 0;
  text-align: center;
  font-size: 1.2em;
  justify-content: center;
  color: ${props => props.theme.secondaryFontColor};
`;

function VehicleLoading() {
  return (
    <PromptWrapper>
      <FormattedMessage id="detailview.vehicleloading" />
    </PromptWrapper>
  );
}
export default VehicleLoading;
